import {
  SET_DEFAULT_VALUE,
  USER_AUTHENTICATION_FAILED,
  USER_AUTHENTICATION_STARTED,
  USER_AUTHENTICATION_SUCCESS,
  LOGOUT_SUCCESS,
} from "../actions/types";

const defaultState = {
  accessToken: "",
  oid: "",
  sessionId: "",
  refreshToken: "",
  tokenType: "",
  expiresIn: "",
  loading: false,
  error: null,
};
const updateUser = (state, action) => {
  if (!state) {
    return defaultState;
  }
  switch (action.type) {
    case USER_AUTHENTICATION_STARTED:
      return {
        ...state.user,
        loading: true,
      };
    case USER_AUTHENTICATION_SUCCESS:
      return {
        ...state.user,
        accessToken: action.payload.accessToken,
        oid: action.payload.oid,
        sessionId: action.payload.sessionId,
        refreshToken: action.payload.refreshToken,
        tokenType: action.payload.tokenType,
        expiresIn: action.payload.expiresIn,
        loading: false,
      };
    case USER_AUTHENTICATION_FAILED:
      return {
        ...state.user,
        loading: false,
        error: action.payload.error,
      };
    case LOGOUT_SUCCESS:
    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.user,
      };
  }
};

export default updateUser;
